import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
let mediaMatch = gsap.matchMedia();


/* Smooth scroll to anchor from external page/email. */
/* Activate specific hotspots based on URL parameter. */
window.addEventListener('load', (event) => {
  const path = window.location;
  const pathHash = path.hash;

  if (pathHash) {
    /* if there's a hash in the URL */
    if (pathHash.includes('mml')) {
      document.querySelector('.marquee .marquee__buttons .model-button[data-model="E18MML"]').click();
    } else {
      gsap.to(window, {
        scrollTo: {
          y: pathHash,
          offsetY: 20,
        },
        duration: 1,
      });
    };
  } else if (path.search) {
    /* else if there's a parameter in the URL: ex: ?hotspot=mml-6 */
    /* TODO: finish this so it works for mobile */
    const allParams = (path.search.substring(1)).toLowerCase();
    const paramsArr = allParams.split('&');
    const params = paramsArr[0].split('=');
    // Assumes the "hotspot" parameter is always the first parameter
    const activeHotspot = document.querySelector('.hotspot-button#' + params[1]);

    if (params[1].includes('mcl')) {
      document.querySelector('.marquee .marquee__buttons .model-button[data-model="E18MCL"]').click();
      if (activeHotspot) {
        activeHotspot.click();
      }
    } else if (params[1].includes('mml')) {
      document.querySelector('.marquee .marquee__buttons .model-button[data-model="E18MML"]').click();
      if (activeHotspot) {
        activeHotspot.click();
      }
    }
  }
});

/* Set class on nav items as user scrolls down */
const sectionAnchors = document.querySelectorAll('section[id].anchor-item');
const navAnchors = document.querySelectorAll('.nav__menu .nav__item:not(.nav__item--contact):not(.nav__item--external)');

sectionAnchors.forEach((sectionAnchor, i) => {
    ScrollTrigger.create({
      trigger: sectionAnchor,
      start: "top 50%",

      onEnter: () => {
        navAnchors.forEach((e) => {
          e.classList.remove("nav__item--active");
        });
        navAnchors[i].classList.add("nav__item--active");
      },
      onEnterBack: () => {
        navAnchors.forEach((e) => {
          e.classList.remove("nav__item--active");
        });
        navAnchors[i].classList.add("nav__item--active");
      }
    });
});


/* Scroll user down when menu item is clicked - Desktop and Mobile */
const navItems = document.querySelectorAll('.nav__menu .nav__item:not(.nav__item--contact):not(.nav__item--external)');

navItems.forEach((navItem) => {
  navItem.addEventListener('click', (e) => {
    e.preventDefault();

    /* if the mobile nav overlay is open when a menu item is clicked, close it */
    if (document.querySelector('.nav__menu--mobile.open-nav')) {
      document.querySelector('.nav__menu--mobile .dropdown-toggle').click();
    };

    const navLink = navItem.querySelector('a').getAttribute('href');

    gsap.to(window, {
      scrollTo: {
        y: navLink,
        offsetY: 20,
      },
      duration: 1,
    });
  });
});


/************ ACCESSORIES ANIMATION ************/
mediaMatch.add('(min-width: 800px)', () => {
  ScrollTrigger.create({
    trigger: '.access',
    start: '0px 20%',
    end: 'bottom-=130px 75%',
    pin: '.access__pin',
    scrub: true,
    markers: false,
  });
});


/************ MARQUEE ANIMATIONS ************/
const models = gsap.utils.selector('.marquee__models')('.marquee__model');
let activeScrollTrigger = 'E18MCL';

/* Move the active image down to the next section on scrollTrigger */
mediaMatch.add('(min-width: 1024px)', () => {

  models.forEach((model, index) => {

    /* dynamically get the height of the models in the marquee section before animation */
    function modelHeightDyn() {
      const modelContainer = model.offsetHeight;
      return modelContainer;
    }

    /* dynamically position the models in the features section */
    function modelPositioningDyn(loc, index) {
      let browserWidth = window.innerWidth;
      let modelPositioning = [];
      const modelPos = model.dataset.position;
      modelPositioning = modelPos.split(',');

      /* index 0 is the left model */
      if (index == 0) {
        const marqueeModels = document.querySelector('.marquee__models');
        const marqueeModelWidth = (marqueeModels.clientWidth * .5);
        let windowVW = 0;

        if (browserWidth < 1280) {
          modelPositioning = ['-52%', '126%'];
        } else if (browserWidth < 1350) {
          modelPositioning = ['-59%', '135%'];
        } else if (browserWidth < 1450) {
          windowVW = (window.innerWidth * .18) + 221;
          modelPositioning = [((marqueeModelWidth) - windowVW) * 1, '135%'];
        }
      }

      /* index 1 is the right model */
      if (index == 1) {
        const marqueeModels = document.querySelector('.marquee__models');
        const marqueeModelWidth = (marqueeModels.clientWidth * .5) * 1.375;
        let windowVW = 0;

        if (browserWidth < 1280) {
          windowVW = (window.innerWidth * .18) - 204;
          modelPositioning = [((marqueeModelWidth) - windowVW) * -1, '126%'];
        } else if (browserWidth < 1350) {
          windowVW = (window.innerWidth * .18) - 270;
          modelPositioning = [((marqueeModelWidth) - windowVW) * -1, '136%'];
        } else if (browserWidth < 1430) {
          windowVW = (window.innerWidth * .17) - 255;
          modelPositioning = ['-178%', '136%'];
        }
      }

      if (loc == 'x') {
        return modelPositioning[0];
      } else {
        return modelPositioning[1];
      }
    }

    const modelAnimation = gsap.fromTo(
      model,
      {
        x: '0',
        y: '0',
        height: modelHeightDyn,
      },
      {
        x: () => modelPositioningDyn('x', index),
        y: () => modelPositioningDyn('y', index),
        height: '700px',
        ease: 'none',
      }
    );

    const modelST = ScrollTrigger.create({
      invalidateOnRefresh: true,
      trigger: '.marquee',
      animation: modelAnimation,
      id: model.dataset.image,
      start: '34px top',
      end: 'bottom 30%',
      scrub: true,
      markers: false
    });

    if (model.dataset.image !== activeScrollTrigger) modelST.disable();
  });

});


/* Fade model section in - Desktop */
const modelSections = document.querySelectorAll('.model > div');
mediaMatch.add('(min-width: 1024px)', () => {

  modelSections.forEach((modelSection) => {
    const fadeinAnimation = gsap.fromTo(
      modelSection,
      {
        opacity: '0',
        zIndex: 1,
      },
      {
        opacity: '100%',
        zIndex: 10,
        duration: .25,
        ease: 'none'
      }
    );

    const sectionST = ScrollTrigger.create({
      trigger: '.model',
      animation: fadeinAnimation,
      id: (modelSection.dataset.model + '_section'),
      start: 'top center',
      end: 'center 30%',
      toggleActions: 'restart none none reverse',
      scrub: false,
      markers: false,
    });

    if (modelSection.dataset.model !== activeScrollTrigger) sectionST.disable();
  });
});

/* Slowly scroll to Models section, activating scrollTrigger */
let marqueeBtns = gsap.utils.toArray('.marquee__buttons .model-button');
marqueeBtns.forEach((btnLink) => {
  let element = document.querySelector(btnLink.dataset.target),
    btnST = ScrollTrigger.create({
      trigger: element,
      start: 'top top',
      end: 'bottom center'
    });

  btnLink.addEventListener('click', (e) => {
    e.preventDefault();
    const target = e.target.dataset.model;

    setButtonState(target);

    if (target !== activeScrollTrigger) {
      /* disable/enable model image ST */
      ScrollTrigger.getById(activeScrollTrigger).disable();
      ScrollTrigger.getById(target).enable();

      /* Needed a unique ID for the model section ST */
      ScrollTrigger.getById(activeScrollTrigger + '_section').disable();
      ScrollTrigger.getById(target + '_section').enable();

      /* Toggle active model section */
      if (modelSections[0].dataset.model == target && !modelSections[0].classList.contains('model--active')) {
        modelSections[0].classList.add('model--active');
        modelSections[1].classList.remove('model--active');
      } else if (modelSections[1].dataset.model == target && !modelSections[1].classList.contains('model--active')) {
        modelSections[1].classList.add('model--active');
        modelSections[0].classList.remove('model--active');
      }

      activeScrollTrigger = target;
    }

    /* scroll model down to next section */
    gsap.to(window, {
      duration: 1.5,
      scrollTo: btnST.start,
      overwrite: 'auto'
    });
  });
});


/* Button Functionality in the Model Section */
let modelBtns = gsap.utils.toArray('.model__buttons .model-button');
modelBtns.forEach((btnLink) => {
  let element = document.querySelector(btnLink.dataset.target),
    btnST = ScrollTrigger.create({
      trigger: element,
      start: 'top top',
      end: 'bottom center'
    });

  btnLink.addEventListener('click', (e) => {
    e.preventDefault();

    const target = e.target.dataset.model;

    setButtonState(target);

    if (target !== activeScrollTrigger) {
      /* disable/enable model image ST */
      /* needed just for desktop, this ST does not exist on mobile */
      if (ScrollTrigger.getById(activeScrollTrigger)) {
        ScrollTrigger.getById(activeScrollTrigger).disable();
        ScrollTrigger.getById(target).enable();
      }

      /* Needed a unique ID for the model section ST */
      if (ScrollTrigger.getById(activeScrollTrigger + '_section')) {
        ScrollTrigger.getById(activeScrollTrigger + '_section').disable();
        ScrollTrigger.getById(target + '_section').enable();
      }

      /* Toggle active model section */
      if (modelSections[0].dataset.model == target && !modelSections[0].classList.contains('model--active')) {
        modelSections[0].classList.add('model--active');
        modelSections[1].classList.remove('model--active');
      } else if (modelSections[1].dataset.model == target && !modelSections[1].classList.contains('model--active')) {
        modelSections[1].classList.add('model--active');
        modelSections[0].classList.remove('model--active');
      }
      // console.log(modelSections[0].dataset.model + ':' + target + ':' + !modelSections[0].classList.contains('model--active'));

      activeScrollTrigger = target;
    }
  });
});


/* Add the active class to the button in the model section that matches what was clicked in the marquee section */
function setButtonState(target) {
  let modelButtons = document.querySelectorAll('.model__buttons .model-button');
  modelButtons.forEach(button => {
    if (target == button.dataset.model) {
      button.classList.add('button--active');
    } else {
      button.classList.remove('button--active');
    }
  });
};